import { render, staticRenderFns } from "./IncomeSummaryFS.vue?vue&type=template&id=1f009e24&scoped=true"
import script from "./IncomeSummaryFS.vue?vue&type=script&lang=ts"
export * from "./IncomeSummaryFS.vue?vue&type=script&lang=ts"
import style0 from "./IncomeSummaryFS.vue?vue&type=style&index=0&id=1f009e24&prod&lang=scss"
import style1 from "./IncomeSummaryFS.vue?vue&type=style&index=1&id=1f009e24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f009e24",
  null
  
)

export default component.exports